import { Button, Flex, Menu, MenuButton, MenuItem, MenuList, Portal } from '@chakra-ui/react';

import {
  Calculator,
  ChevronDown,
  CircleDot,
  DefaultToolTip,
  FileCsv,
  FileExcel,
  FileExport,
  FilePdf,
} from '@enterprise/ui';

import type { ReportGridProps } from '@feat/reports/components/types/report-grid.props';

import { useMergePurgeHeaderConfiguration } from './hooks/merge-purge-header-configuration.hook';

export default function MergePurgeHeader({ view }: Pick<ReportGridProps, 'view'>) {
  const {
    canNth,
    exportToCSV,
    exportToExcel,
    exportToPDF,
    handleToggleNthCalculator,
    hasDraft,
    isOpen,
    onClose,
    onOpen,
  } = useMergePurgeHeaderConfiguration(view);

  return (
    <Flex
      alignItems="center"
      bg="gray.100"
      borderBottom="1px solid"
      borderBottomColor="gray.500"
      gap={2}
      justifyContent="flex-end"
      p={3}>
      {canNth && (
        <Button
          colorScheme="purple"
          leftIcon={<Calculator widthAuto />}
          onClick={handleToggleNthCalculator}
          rightIcon={
            hasDraft ? (
              <DefaultToolTip
                label="Unsaved changes"
                placement="top">
                <CircleDot
                  color="var(--chakra-colors-orange-300)"
                  widthAuto
                />
              </DefaultToolTip>
            ) : undefined
          }>
          Nth Calculator
        </Button>
      )}
      {view === 'full-report' && (
        <Button
          colorScheme="hsp"
          leftIcon={<FilePdf widthAuto />}
          onClick={exportToPDF}
          transition="all 0.2s">
          Export as PDF
        </Button>
      )}
      {view !== 'full-report' && (
        <Menu
          gutter={0}
          isLazy
          isOpen={isOpen}
          placement="bottom-end">
          <MenuButton
            _focus={{ boxShadow: 'outline' }}
            as={Button}
            colorScheme="hsp"
            leftIcon={<FileExport widthAuto />}
            onMouseEnter={onOpen}
            onMouseLeave={onClose}
            rightIcon={<ChevronDown widthAuto />}
            transition="all 0.2s">
            Export
          </MenuButton>
          <Portal>
            <MenuList
              borderColor="hsp.500"
              onMouseEnter={onOpen}
              onMouseLeave={onClose}>
              <MenuItem
                _hover={{ bg: 'hsp.500', color: 'white' }}
                icon={
                  <FileCsv
                    size="lg"
                    widthAuto
                  />
                }
                onClick={exportToCSV}
                p={3}>
                Export as CSV
              </MenuItem>
              <MenuItem
                _hover={{ bg: 'hsp.500', color: 'white' }}
                icon={
                  <FileExcel
                    size="lg"
                    widthAuto
                  />
                }
                onClick={exportToExcel}
                p={3}>
                Export as Excel
              </MenuItem>
              <MenuItem
                _hover={{ bg: 'hsp.500', color: 'white' }}
                icon={
                  <FilePdf
                    size="lg"
                    widthAuto
                  />
                }
                onClick={exportToPDF}
                p={3}>
                Export as PDF
              </MenuItem>
            </MenuList>
          </Portal>
        </Menu>
      )}
    </Flex>
  );
}
